import type { OrderStatus } from '@/types/order';

// ── Language ───────────────────────────────────────────────────────

export const SUPPORTED_LANGUAGES = ['zh', 'en', 'ms'] as const;
export const DEFAULT_LANGUAGE = 'en';
export const LANG_STORAGE_KEY = 'goloka_lang';

// ── API ────────────────────────────────────────────────────────────

export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || '/api/v1';

/**
 * Frontend route the backend redirects to after a social login. Must match
 * the path of the backend's OAUTH_FRONTEND_CALLBACK_URL.
 */
export const OAUTH_CALLBACK_PATH = '/oauth/callback';

// ── File upload ────────────────────────────────────────────────────

/** Maximum file size before compression: 10 MB */
export const MAX_FILE_SIZE = 10 * 1024 * 1024;

/** Maximum file size after compression: 5 MB */
export const MAX_COMPRESSED_SIZE = 5 * 1024 * 1024;

/** Allowed image MIME types for upload */
export const ALLOWED_IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/avif',
] as const;

// ── React Query defaults ───────────────────────────────────────────

/** Data considered fresh for 5 minutes */
export const STALE_TIME = 5 * 60 * 1000;

/** Unused cache garbage-collected after 30 minutes */
export const GC_TIME = 30 * 60 * 1000;

// ── Version check ──────────────────────────────────────────────────

/** Poll for new version every 5 minutes */
export const VERSION_CHECK_INTERVAL = 5 * 60 * 1000;

// ── Order status colors ────────────────────────────────────────────

export const ORDER_STATUS_COLORS: Record<OrderStatus, string> = {
  pending: 'yellow',
  paid: 'green',
  refund_pending: 'orange',
  cancelled: 'gray',
  refunded: 'blue',
};
